module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sem-permissao",
    attrs: {
      "id": "sem-permissao"
    }
  }, [_c('div', {
    staticClass: "estado-vazio estado-vazio_largura-grande sem-permissao__conteudo"
  }, [_c('i', {
    staticClass: "far fa-lock estado-vazio__icone"
  }), _vm._v(" "), _c('h2', {
    staticClass: "estado-vazio__titulo"
  }, [_vm._v("Acesso negado")]), _vm._v(" "), _c('p', {
    staticClass: "estado-vazio__texto"
  }, [_vm._v("\n      Você não possui permissão para acessar o Controle de Saldo.\n      "), _c('br'), _vm._v("\n      Entre em contato com o administrador do sistema para solicitar o seu\n      acesso.\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc0ee130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sem-permissao/SemPermissao.vue
// module id = 1141
// module chunks = 1